/****************************************************************************************
 * File Name    : FilterProcessRegister.vue
 * Function     : 필터 공정순회 점검일지 - 신규등록
 * Author       : 
 * Description  : 공정순회 점검 템플릿 생성 및 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div class="">
        <div v-if="flagSpinner === false">
            <a-row :gutter="16">
                <a-col class="gutter-row" :span="24">
                    <div class="gutter-box">
                        <PageHeader title="필터 공정순회 점검일지 - 신규등록" />
                    </div>
                </a-col>
            </a-row>
            <a-divider type='horizontal' />
            
            <a-space align="end" style="padding-top:10px;">
                <a-radio-group v-model="filterState">
                    <a-radio-button @click="changeFilterState('등록중')" value="등록중">등록중만 보기</a-radio-button>
                    <a-radio-button @click="changeFilterState('등록완료')" value="등록완료">등록완료만 보기</a-radio-button>
                    <a-radio-button @click="changeFilterState('모두')" value="모두">모두보기</a-radio-button>
                </a-radio-group>
                <a-input placeholder="검색할 이름을 입력하세요" v-model="filterCS" />
                <a-button type="primary" ghost="true" @click="filterCSList">검색</a-button>
                <a-button @click="resetCSList">초기화</a-button>
                <a-divider type='vertical' />
                <div class="border:1px solid red;width:100%">
                    <a-button type="primary" icon="plus-circle" size="default" @click="showCreateModal">
                        공정순회 점검일지 템플릿 생성
                    </a-button>
                </div>
            </a-space>
            <p/>
            <a-progress type='line' :percent="validRate" strokeColor='#C7C6C6'/>
            <p/>
            
            <a-table :columns="columns" size="small" :bordered="false" :data-source="data" :pagination="pagination" :scroll="{ x: 0, y: '57vh' }" @change="handleTableChange">
                <span slot="tags" slot-scope="tag">
                    <a-tag class="state-btn" :class="{ red: (tag === '등록중'), green: (tag === '등록완료') }">
                        {{ tag.toUpperCase() }}
                    </a-tag>
                </span>
                <span slot="name" slot-scope="text">{{ text }}</span>
                <span slot="action" slot-scope="record">
                    <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                    <a-divider type="vertical" />
                    <span style='cursor:pointer' @click="handlerToCopy(record.key)"><a-icon type="copy" /> 복사생성</span>
                    <a-divider type="vertical" />
                    <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
                    <a-divider type="vertical" />
                    <span style='cursor:pointer' @click="handlerToView(record.key)"><a-icon type="eye" /> View</span>
                </span>
            </a-table>
        </div>
        <a-skeleton v-else />

        <!-- 템플릿 생성/수정 Modal -->
        <a-modal
            v-model="isCreateModalVisible"
            :title="modalTitle"
            width="90%"
            :footer="null"
            @cancel="handleModalCancel"
        >
            <a-form :form="form" layout="vertical">
                <!-- 기본정보 -->
                <a-card title="기본정보" :bordered="false" style="margin-bottom: 16px;">
                    <a-row :gutter="16">
                        <a-col :span="6">
                            <a-form-item label="템플릿명">
                                <a-input v-model="formData.basicInfo.templateName" placeholder="템플릿명" :disabled="viewMode" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="라인명">
                                <a-input v-model="formData.basicInfo.lineName" placeholder="라인명" :disabled="viewMode" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="작성자">
                                <a-input v-model="formData.basicInfo.writer" placeholder="작성자" :disabled="viewMode" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-item label="생산 모델">
                                <a-select
                                    v-model="formData.basicInfo.productSeq"
                                    show-search
                                    placeholder="모델명 또는 제품명으로 검색"
                                    :filter-option="filterProductOption"
                                    style="width: 100%"
                                    allow-clear
                                    option-label-prop="label"
                                    :disabled="viewMode"
                                >
                                    <a-select-option
                                        v-for="p in productList"
                                        :key="p.productSeq"
                                        :value="p.productSeq"
                                        :label="`${p.productModel} (${p.productName})`"
                                    >
                                        {{ p.productModel }} ({{ p.productName }})
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-card>

                <!-- 공정명 체크항목 등록 -->
                <a-card title="공정명 체크항목 등록" :bordered="false" style="margin-bottom: 16px;">
                    <!-- <div v-if="!viewMode" class="list-add-bar" style="margin-bottom: 16px;">
                        <a-button type="dashed" block @click="addProcessItem">
                            <a-icon type="plus" /> 공정 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.process">값 복사</a-checkbox>
                    </div> -->
                    <a-table 
                        :columns="processColumns" 
                        :data-source="formData.processes" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="processName" slot-scope="text, record">
                            <a-input v-model="record.processName" placeholder="공정명" :disabled="viewMode" />
                        </template>
                        <template slot="checkPoint" slot-scope="text, record">
                            <a-input v-model="record.checkPoint" placeholder="Check Point" :disabled="viewMode" />
                        </template>
                        <template slot="rowCount" slot-scope="text, record">
                            <a-select v-model="record.rowCount" style="width: 90px;" :disabled="viewMode">
                                <a-select-option v-for="n in 10" :key="n" :value="n">{{ n }}줄</a-select-option>
                            </a-select>
                        </template>
                        <template slot="action" slot-scope="text, record, index">
                            <a-button v-if="!viewMode" type="link" size="small" @click="removeProcessItem(index)">
                                <a-icon type="delete" />
                            </a-button>
                            <span v-else>-</span>
                        </template>
                    </a-table>
                    <div v-if="!viewMode" class="list-add-bar" style="margin-top: 16px;">
                        <a-button type="dashed" block @click="addProcessItem">
                            <a-icon type="plus" /> 공정 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.process">값 복사</a-checkbox>
                    </div>
                </a-card>

                <!-- 점검 라인 등록 -->
                <a-card title="점검 라인 등록 (라인명 설정)" :bordered="false" style="margin-bottom: 16px;">
                    <!-- <div v-if="!viewMode" class="list-add-bar" style="margin-bottom: 16px;">
                        <a-button type="dashed" block @click="addCheckLineItem">
                            <a-icon type="plus" /> 라인 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.checkLine">값 복사</a-checkbox>
                    </div> -->
                    <a-table 
                        :columns="checkLineColumns" 
                        :data-source="formData.checkLines" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="lineName" slot-scope="text, record">
                            <a-input v-model="record.lineName" placeholder="라인명 (예: CF01, CF02)" :disabled="viewMode" />
                        </template>
                        <template slot="action" slot-scope="text, record, index">
                            <a-button v-if="!viewMode" type="link" size="small" @click="removeCheckLineItem(index)">
                                <a-icon type="delete" />
                            </a-button>
                            <span v-else>-</span>
                        </template>
                    </a-table>
                    <div v-if="!viewMode" class="list-add-bar" style="margin-top: 16px;">
                        <a-button type="dashed" block @click="addCheckLineItem">
                            <a-icon type="plus" /> 라인 추가
                        </a-button>
                        <a-checkbox v-model="copyOnAdd.checkLine">값 복사</a-checkbox>
                    </div>
                </a-card>

                <a-divider />
                <div style="text-align: center;">
                    <a-button @click="handleModalCancel" style="margin-right: 8px;">닫기</a-button>
                    <template v-if="!viewMode">
                        <a-button type="default" @click="handleSaveTemp" style="margin-right: 8px;">임시저장</a-button>
                        <a-button type="primary" @click="handleSaveComplete">저장완료</a-button>
                    </template>
                </div>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import PageHeader from "../components/PageHeader.vue";

const columns = [
    { title: '상태', dataIndex: 'tag', key: 'tag', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '템플릿명', dataIndex: 'name', key: 'name', scopedSlots: { customRender: 'name' } },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '생산모델', dataIndex: 'productModel', key: 'productModel' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 320 },
];

const processColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '공정명', key: 'processName', scopedSlots: { customRender: 'processName' } },
    { title: 'Check Point', key: 'checkPoint', scopedSlots: { customRender: 'checkPoint' } },
    { title: '입력 행 수', key: 'rowCount', scopedSlots: { customRender: 'rowCount' }, width: 120 },
    { title: '삭제', key: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
];

const checkLineColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '라인명', key: 'lineName', scopedSlots: { customRender: 'lineName' } },
    { title: '삭제', key: 'action', scopedSlots: { customRender: 'action' }, width: 80 },
];

export default {
    name: 'FilterProcessRegister',
    components: {
        PageHeader,
    },
    data() {
        return {
            flagSpinner: false,
            filterState: '모두',
            filterCS: '',
            validRate: 100,
            columns,
            processColumns,
            checkLineColumns,
            data: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            isCreateModalVisible: false,
            editingSeq: null,
            viewMode: false,
            copyMode: false,
            copyOnAdd: {
                process: false,
                checkLine: false,
            },
            productList: [],
            form: this.$form.createForm(this),
            formData: {
                basicInfo: {
                    templateName: '',
                    lineName: '',
                    writer: '',
                    productSeq: null,
                    dateTime: ''
                },
                processes: [],
                checkLines: []
            }
        };
    },
    mounted() {
        this.fetchTemplateList();
        this.fetchProductList();
    },
    computed: {
        modalTitle() {
            if (this.viewMode) return '공정순회 점검일지 템플릿 조회';
            if (this.copyMode) return '공정순회 점검일지 템플릿 복사생성';
            if (this.editingSeq) return '공정순회 점검일지 템플릿 수정';
            return '공정순회 점검일지 템플릿 생성';
        },
    },
    methods: {
        fetchTemplateList() {
            this.flagSpinner = true;
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            let url = `${this.$store.state.nodeApiUrl}/filter/process/template/list?size=${size}&page=${page}`;
            
            if (this.filterState === '등록중') url += '&state=FP_A';
            else if (this.filterState === '등록완료') url += '&state=FP_B';
            if (this.filterCS) url += `&name=${encodeURIComponent(this.filterCS)}`;
            
            this.$http.get(url)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.data = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tag: item.state === 'FP_A' ? '등록중' : '등록완료',
                            name: item.name,
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            updated: item.updated
                        }));
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('목록 조회에 실패했습니다.');
                    this.flagSpinner = false;
                });
        },
        changeFilterState(state) {
            this.filterState = state;
            this.filterCSList();
        },
        filterCSList() {
            this.pagination.current = 1;
            this.fetchTemplateList();
        },
        resetCSList() {
            this.filterCS = '';
            this.filterState = '모두';
            this.pagination.current = 1;
            this.fetchTemplateList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchTemplateList();
        },
        showCreateModal() {
            this.viewMode = false;
            this.copyMode = false;
            this.isCreateModalVisible = true;
            this.resetFormData();
            this.formData.basicInfo.writer = sessionStorage.getItem('user_name') || '';
        },
        handleModalCancel() {
            this.isCreateModalVisible = false;
            this.viewMode = false;
            this.copyMode = false;
            this.resetFormData();
        },
        resetFormData() {
            this.editingSeq = null;
            this.copyMode = false;
            this.copyOnAdd = {
                process: false,
                checkLine: false,
            };
            this.formData = {
                basicInfo: {
                    templateName: '',
                    lineName: '',
                    writer: '',
                    productSeq: null,
                    dateTime: ''
                },
                processes: [],
                checkLines: []
            };
        },
        fetchProductList() {
            this.$http.get(`${this.$store.state.nodeApiUrl}/product/list?size=1000`)
                .then(response => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.productList = response.data.data.content;
                    }
                })
                .catch(err => console.error(err));
        },
        filterProductOption(input, option) {
            const label = (option.componentOptions.propsData.label || '').toLowerCase();
            return label.includes(input.toLowerCase());
        },
        hasAnyRowValue(row, fieldKeys) {
            return fieldKeys.some((key) => {
                const value = row[key];
                if (value == null) return false;
                return String(value).trim() !== '';
            });
        },
        pushListItem(list, template, fieldKeys, copyEnabled) {
            if (!list.length || !copyEnabled) {
                list.push({ ...template });
                return;
            }
            const prev = list[list.length - 1];
            if (!this.hasAnyRowValue(prev, fieldKeys)) {
                list.push({ ...template });
                return;
            }
            const item = { ...template };
            fieldKeys.forEach((key) => {
                item[key] = prev[key];
            });
            list.push(item);
        },
        addProcessItem() {
            const list = this.formData.processes;
            // rowCount는 텍스트 필드가 아니므로 hasAnyRowValue 검사에서 제외하고, 복사 시에만 별도 반영
            const shouldCopy = this.copyOnAdd.process &&
                               list.length > 0 &&
                               this.hasAnyRowValue(list[list.length - 1], ['processName', 'checkPoint']);
            const prevRowCount = shouldCopy ? (list[list.length - 1].rowCount || 1) : 1;
            this.pushListItem(
                list,
                { processName: '', checkPoint: '', rowCount: prevRowCount },
                ['processName', 'checkPoint'],
                this.copyOnAdd.process,
            );
        },
        removeProcessItem(index) {
            this.formData.processes.splice(index, 1);
        },
        addCheckLineItem() {
            this.pushListItem(
                this.formData.checkLines,
                { lineName: '' },
                ['lineName'],
                this.copyOnAdd.checkLine,
            );
        },
        removeCheckLineItem(index) {
            this.formData.checkLines.splice(index, 1);
        },
        loadTemplateIntoForm(data, { viewMode = false, editingSeq = null, copyMode = false } = {}) {
            this.viewMode = viewMode;
            this.copyMode = copyMode;
            this.editingSeq = editingSeq;

            this.formData.basicInfo.templateName = copyMode ? '' : (data.name || '');
            this.formData.basicInfo.lineName = data.line || '';
            this.formData.basicInfo.writer = copyMode
                ? (sessionStorage.getItem('user_name') || '')
                : (data.manager || '');
            this.formData.basicInfo.productSeq = data.productSeq || null;

            this.formData.processes = (data.processes || []).map(p => ({
                ...p,
                rowCount: p.rowCount || 1
            }));
            this.formData.checkLines = JSON.parse(JSON.stringify(data.checkLines || []));
        },
        fetchTemplateItem(key, onSuccess) {
            this.$http.get(`${this.$store.state.nodeApiUrl}/filter/process/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        onSuccess(response.data.data);
                    } else {
                        this.$message.error('데이터 조회에 실패했습니다.');
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('데이터 조회에 실패했습니다.');
                });
        },
        handleSaveTemp() {
            this.saveTemplate('FP_A');
        },
        handleSaveComplete() {
            this.saveTemplate('FP_B');
        },
        checkDuplicateTemplateName(name) {
            return new Promise((resolve) => {
                const url = `${this.$store.state.nodeApiUrl}/filter/process/template/list?size=1000&page=0&name=${encodeURIComponent(name)}`;
                this.$http.get(url)
                    .then((response) => {
                        if (response.status === 200 && response.data.code === 'success') {
                            const items = response.data.data.content || [];
                            const isDuplicate = items.some(item => {
                                if (!this.copyMode && this.editingSeq && item.productCsSeq === this.editingSeq) {
                                    return false;
                                }
                                return item.name === name;
                            });
                            resolve(isDuplicate);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(() => resolve(false));
            });
        },
        saveTemplate(state) {
            const templateName = this.formData.basicInfo.templateName || '공정점검 템플릿';
            this.flagSpinner = true;
            this.checkDuplicateTemplateName(templateName).then((isDuplicate) => {
                if (isDuplicate) {
                    this.$message.error(`'${templateName}' 템플릿명이 이미 존재합니다. 다른 이름을 입력해주세요.`);
                    this.flagSpinner = false;
                    return;
                }
                this.persistTemplate(state);
            });
        },
        persistTemplate(state) {
            const postData = {
                name: this.formData.basicInfo.templateName || '공정점검 템플릿',
                state: state,
                lineName: this.formData.basicInfo.lineName,
                writer: this.formData.basicInfo.writer,
                productSeq: this.formData.basicInfo.productSeq,
                creator: sessionStorage.getItem('user_name') || 'system',
                updater: sessionStorage.getItem('user_name') || 'system',
                processes: this.formData.processes,
                checkLines: this.formData.checkLines
            };
            
            this.flagSpinner = true;

            const isEdit = !!this.editingSeq;
            const url = isEdit
                ? `${this.$store.state.nodeApiUrl}/filter/process/template/update/${this.editingSeq}`
                : `${this.$store.state.nodeApiUrl}/filter/process/template/create`;
            const request = isEdit ? this.$http.put(url, postData) : this.$http.post(url, postData);

            request
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success(state === 'FP_A' ? '임시저장되었습니다.' : '저장되었습니다.');
                        this.handleModalCancel();
                        this.fetchTemplateList();
                    }
                    this.flagSpinner = false;
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('저장에 실패했습니다.');
                    this.flagSpinner = false;
                });
        },
        handlerToEdit(key) {
            this.fetchTemplateItem(key, (data) => {
                this.loadTemplateIntoForm(data, { editingSeq: key });
                this.isCreateModalVisible = true;
            });
        },
        handlerToCopy(key) {
            this.fetchTemplateItem(key, (data) => {
                this.loadTemplateIntoForm(data, { copyMode: true, editingSeq: null });
                this.isCreateModalVisible = true;
            });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/filter/process/template/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchTemplateList();
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('삭제에 실패했습니다.');
                        });
                }
            });
        },
        handlerToView(key) {
            this.fetchTemplateItem(key, (data) => {
                this.loadTemplateIntoForm(data, { viewMode: true, editingSeq: null });
                this.isCreateModalVisible = true;
            });
        }
    }
};
</script>

<style scoped>
.list-add-bar {
    display: flex;
    align-items: center;
    gap: 12px;
}
.list-add-bar .ant-btn {
    flex: 1;
}
.state-btn {
    font-weight: bold;
    padding: 2px 8px;
}
.state-btn.red {
    background-color: #ff4d4f;
    color: white;
}
.state-btn.green {
    background-color: #52c41a;
    color: white;
}
</style>
